export default __webpack_public_path__ + "static/media/mute-video-on.31bf8b3f.svg";